import moment from 'moment';

export const fetchKioskBinsUtilizationReport = async ({
  sinceDays = 31,
  timeZone = moment.tz.guess(),
  accountId,
}) => {
  try {
    const _res = await fetch(
      process.env.REACT_APP_BASEURL +
        `reports/boxUtilization/bins?sinceDays=${sinceDays}&timezone=${timeZone}${
          accountId ? '&account=' + accountId : ''
        }`,
      {
        method: 'GET',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );

    // Check for HTTP errors
    if (!_res.ok) throw new Error(`HTTP error! status: ${_res.status}`);
    const _data = await _res.json();

    // return if data is non-empty
    if (_data && Array.isArray(Object.keys(_data))) return _data;
    console.log('Empty Body While Calling Kiosk binsUtilizationReport');
  } catch (error) {
    console.warn('Error Body While Calling Kiosk binsUtilizationReport', error);
  }
};

export const fetchKioskOrdersUtilizationReport = async ({
  sinceDays = 31,
  timeZone = moment.tz.guess(),
  accountId,
}) => {
  try {
    const _res = await fetch(
      process.env.REACT_APP_BASEURL +
        `reports/boxUtilization/orders?groupBy=date&sinceDays=${sinceDays}&timezone=${timeZone}${
          accountId ? '&account=' + accountId : ''
        }`,
      {
        method: 'GET',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );

    // Check for HTTP errors
    if (!_res.ok) throw new Error(`HTTP error! status: ${_res.status}`);
    const _data = await _res.json();

    // return if data is non-empty
    if (_data && Array.isArray(Object.keys(_data))) return _data;
    console.log('Empty Body While Calling kiosk ordersUtilizationReport');
  } catch (error) {
    console.warn(
      'Error Body While Calling kisok ordersUtilizationReport',
      error
    );
  }
};

export const fetchAccounts = async () => {
  try {
    const _res = await fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    });

    // Check for HTTP errors
    if (!_res.ok) throw new Error(`HTTP error! status: ${_res.status}`);
    const _data = await _res.json();

    // return if data is non-empty
    if (_data && Array.isArray(_data))
      return _data.map(({ id, name }) => ({
        id,
        name,
        uiValue: id.slice(0, 8),
      }));

    console.log('Unexpected Body While fetching accounts');
  } catch (error) {
    console.warn('Error Body While fetching accounts', error);
  }
};



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/helpers/api.helpers.js